import React from 'react';
import PublicLayout from '@/components/PublicLayout';
import SEO from '@/components/SEO';
import { Shield, AlertTriangle, Phone, Mail } from 'lucide-react';

const FraudAlertPage = () => (
  <PublicLayout>
    <SEO title="Fraud Alert" description="Beware of fraudulent job offers. Learn how to identify scams and protect yourself when applying for teaching jobs in India." path="/fraud-alert" />
    <div className="max-w-4xl mx-auto px-4 py-16" data-testid="fraud-alert-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center">
          <AlertTriangle className="w-6 h-6 text-red-600" />
        </div>
        <div>
          <h1 className="text-3xl lg:text-4xl font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>Fraud Alert</h1>
          <p className="text-slate-500">Protect yourself from recruitment scams</p>
        </div>
      </div>

      <div className="prose prose-slate max-w-none">
        <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
          <h3 className="text-red-800 mt-0">Important Notice</h3>
          <p className="text-red-700 mb-0">EdAssist (HRassistance India Consultancy LLP) does <strong>NOT</strong> charge any fees from job seekers at any stage of the recruitment process — including application, interview, or onboarding. If anyone asks you for money claiming to represent EdAssist, it is a scam.</p>
        </div>

        <h2>How to Identify Fake Job Offers</h2>
        <ul>
          <li>Unsolicited job offers via SMS, WhatsApp, or personal email</li>
          <li>Requests for payment for job placement, registration, or interview</li>
          <li>Use of generic email addresses (Gmail, Yahoo) instead of official EdAssist domains</li>
          <li>Offers that sound "too good to be true" — unrealistic salaries, no interview needed</li>
          <li>Pressure to act immediately or share personal banking details</li>
        </ul>

        <h2>What EdAssist Will Never Do</h2>
        <ul>
          <li>Ask candidates for money at any stage</li>
          <li>Send job offers from non-official email addresses</li>
          <li>Guarantee job placement in exchange for fees</li>
          <li>Request sensitive banking details like PIN, OTP, or CVV</li>
        </ul>

        <h2>How to Stay Safe</h2>
        <ul>
          <li>Always verify job postings on the official EdAssist platform at <a href="https://edassist.co.in" className="text-indigo-600">edassist.co.in</a></li>
          <li>Do not share OTP, bank account, or credit card details with anyone claiming to be from EdAssist</li>
          <li>Report suspicious activity to us immediately</li>
          <li>Check recruiter/employer profiles on the platform before engaging</li>
        </ul>

        <h2>Report a Scam</h2>
        <p>If you suspect fraudulent activity or have been contacted by someone impersonating EdAssist, please report it immediately:</p>

        <div className="bg-slate-50 border border-slate-200 rounded-xl p-6 not-prose">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-indigo-600" />
              <span className="text-slate-700">Email: <a href="mailto:info@edassist.co.in" className="text-indigo-600 font-medium">info@edassist.co.in</a></span>
            </div>
            <p className="text-sm text-slate-500 mt-2">
              <strong>EdAssist</strong> (HRassistance India Consultancy LLP)<br />
              205A, Town Square, Viman Nagar, Pune-411014, India
            </p>
          </div>
        </div>
      </div>
    </div>
  </PublicLayout>
);

export default FraudAlertPage;
